import { atom } from 'recoil';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastState {
    show: boolean;
    message: string;
    type: ToastType;
}

export const toastState = atom<ToastState>({
    key: 'toastState',
    default: {
        show: false,
        message: '',
        type: 'info',
    },
});
